import { render } from "./MultiSelectAnnotation.vue?vue&type=template&id=1777b888&scoped=true"
import script from "./MultiSelectAnnotation.vue?vue&type=script&lang=js"
export * from "./MultiSelectAnnotation.vue?vue&type=script&lang=js"

import "./MultiSelectAnnotation.vue?vue&type=style&index=0&id=1777b888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1777b888"]])

export default __exports__